import * as React from 'react';
import { useParams } from 'react-router-dom';

import EmptyNote from '@/pages/EmptyNote';
import { useDevices } from '@/utils/devices';

const NoteIndex: React.FC = () => {
  const { noteId } = useParams();
  const { isCompactViewport } = useDevices();

  if (isCompactViewport) {
    return null;
  }

  if (!noteId) {
    return <EmptyNote />;
  }

  return null;
};

export default NoteIndex;
